import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import Ito from '../views/Ito/Index.vue'
import ItoTeam from '../views/Ito/Team/Index.vue'
import ItoTeamSingle from '../views/Ito/Team/Single.vue'
import ItoHistory from '../views/Ito/History.vue'
import ItoPhilosophy from '../views/Ito/Philosophy.vue'
import ItoPartner from '../views/Ito/Partner/Index.vue'
import ItoPartnerSingle from '../views/Ito/Partner/Single.vue'

import Services from '../views/Services/Index.vue'
import ServicesSingle from '../views/Services/Single.vue'
/*
import ITSecurity from '../views/Services/ITSecurity.vue'
import Onlineshops from '../views/Services/Onlineshops.vue'
import Development from '../views/Services/Development.vue'
*/
import Projects from '../views/Projects/Index.vue'
import ProjectSingle from '../views/Projects/Single.vue'
import Jobs from '../views/Jobs/Index.vue'
import JobSingle from '../views/Jobs/Single.vue'
import JobForm from '../views/Jobs/Form.vue'
// import Contact from '../views/Contact.vue'
import Imprint from '../views/Imprint.vue'
import Policy from '../views/Policy.vue'
import Conditions from '../views/Conditions.vue'
import PageNotFound from '../views/PageNotFound.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/wir',
    name: 'ito',
    component: Ito
  },
  {
    path: '/wir/team',
    name: 'ito.team',
    component: ItoTeam,
    meta: { stayAtScrollPositon: true },
    children: [
      {
        path: ':id',
        name: 'ito.team.single',
        component: ItoTeamSingle,
        meta: { stayAtScrollPositon: true }
      }
    ]
  },
  {
    path: '/wir/historie',
    name: 'ito.history',
    component: ItoHistory
  },
  {
    path: '/wir/philosophie',
    name: 'ito.philosophy',
    component: ItoPhilosophy
  },
  {
    path: '/wir/partner',
    name: 'ito.partner',
    component: ItoPartner
  },
  {
    path: '/wir/partner/:id',
    name: 'ito.partner.single',
    component: ItoPartnerSingle
  },
  {
    path: '/leistungen',
    name: 'services',
    component: Services
  },
  {
    path: '/leistungen/:id',
    name: 'services.single',
    component: ServicesSingle
  },
  /* {
    path: '/leistungen/it-sicherheit',
    name: 'services.it-sicherheit',
    component: ITSecurity
    },
    {
      path: '/leistungen/e-commerce',
      name: 'services.e-commerce',
      component: Onlineshops
    },
    {
      path: '/leistungen/development',
      name: 'services.web-appentwicklung',
      component: Development
    },
  */
  {
    path: '/projekte',
    name: 'projects',
    component: Projects
  },
  {
    path: '/projekte/:id',
    name: 'projects.single',
    component: ProjectSingle
  },
  {
    path: '/jobs/',
    name: 'jobs',
    component: Jobs
  },
  {
    path: '/jobs/:id',
    name: 'jobs.single',
    component: JobSingle,
    meta: { stayAtScrollPositon: true },
    children: [
      {
        path: 'form',
        name: 'job.form',
        component: JobForm,
        meta: { stayAtScrollPositon: true }
      }
    ]
  },
  {
    path: '/p/:id',
    name: 'landingpage',
    component: () => import('../views/Page.vue')
  },
  {
    path: '/kontakt',
    name: 'contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/impressum',
    name: 'imprint',
    component: Imprint
  },
  {
    path: '/datenschutz',
    name: 'policy',
    component: Policy
  },
  {
    path: '/agb',
    name: 'conditions',
    component: Conditions
  },
  {
    path: '*',
    name: '404',
    component: PageNotFound
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return false
    } else {
      if (to.meta.stayAtScrollPositon) {
        return false
      } else {
        return { x: 0, y: 0 }
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  store.commit('loadingStatus', true)
  store.commit('noScollBodyStatus', false)
  // SETTING META TAGS
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title
  }
  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))
  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()
  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')
    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })
    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '')
    return tag
  })
  // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag))

  next()
})
router.afterEach((to, from) => {
  // store.commit('loadingStatus', false)
  store.commit('mobileMenuStatus', false)
})

export default router
